import React, { useState } from 'react';
import { createPortal } from 'react-dom'; 
import './RoomControls.css'; 

export default function RoomControls({ onLeave, gs, myId, send }) {
  const [showConfirm, setShowConfirm] = useState(false);
  const isHost = gs && gs.host_id === myId;

  return (
    <>
      {/* Top Left Main Button */}
      <div style={{ position: 'absolute', top: '24px', left: '24px', zIndex: 100, display: 'flex', gap: '8px' }}>
        <button className="leave-btn" onClick={() => setShowConfirm(true)}>
          <span style={{ fontSize: '1.2rem', marginRight: '4px' }}>🚪</span> Leave
        </button>
        {isHost && send && (
          <button 
            className="leave-btn" 
            style={{ 
              backgroundColor: gs?.is_paused ? 'rgba(59, 130, 246, 0.2)' : 'rgba(255,255,255,0.1)',
              borderColor: gs?.is_paused ? '#3b82f6' : 'rgba(255,255,255,0.2)',
              color: gs?.is_paused ? '#60a5fa' : 'white'
            }}
            onClick={() => send('toggle_pause')}
          >
            <span style={{ fontSize: '1.2rem', marginRight: '4px' }}>{gs?.is_paused ? '▶️' : '⏸'}</span> 
            {gs?.is_paused ? 'Resume' : 'Pause'}
          </button>
        )}
      </div>

      {/* The Custom Confirmation Modal - Portaled to document.body */}
      {showConfirm && createPortal(
        <div className="confirm-overlay" onClick={() => setShowConfirm(false)}>
          
          <div className="confirm-modal" onClick={(e) => e.stopPropagation()}>
            <h3>Leave the Table?</h3>
            <p>
              Are you sure you want to return to the lobby? 
              You will give up your seat and your cards.
            </p>
            
            <div className="confirm-actions">
              <button 
                className="confirm-btn cancel" 
                onClick={() => setShowConfirm(false)}
              >
                Cancel
              </button>
              
              <button 
                className="confirm-btn leave" 
                onClick={() => {
                  setShowConfirm(false); 
                  onLeave();             
                }}
              >
                Yes, Leave
              </button>
            </div>
          </div>
        </div>,
        document.body 
      )}
    </>
  );
}